import { LpBanner, LpButton, LpDataTable, LpEmpty, LpIcon, LpModuleGrid, LpModuleGridExpandButton, LpModuleGridItem, LpModuleGridSection, LpTable, html, } from "~/design-system";
const aggregatorWinRateColumns = [
    {
        key: "aggregator",
        label: "Aggregator",
        valueBinding: "aggregator",
        width: 160,
        minWidth: 132,
        required: true,
    },
    {
        key: "winRate",
        label: "Win Rate",
        valueBinding: "$parent.formatNumeric(winRate, 0) + '%'",
        width: 104,
        minWidth: 96,
        required: true,
    },
    {
        key: "deltaWinRate",
        label: "Delta",
        valueBinding: "$parent.formatDelta(deltaWinRate, 0)",
        deltaBinding: "deltaWinRate",
        width: 96,
        minWidth: 88,
        required: true,
    },
];
const carrierWinRateColumns = [
    {
        key: "carrier",
        label: "Carrier",
        valueBinding: "carrier",
        width: 160,
        minWidth: 132,
        required: true,
    },
    ...aggregatorWinRateColumns.slice(1),
];
const carrierCtrColumns = [
    {
        key: "carrier",
        label: "Carrier",
        valueBinding: "carrier",
        width: 152,
        minWidth: 124,
        required: true,
    },
    {
        key: "ctr",
        label: "CTR",
        valueBinding: "$parent.formatNumeric(ctr, 2) + '%'",
        width: 88,
        minWidth: 80,
        required: true,
    },
    {
        key: "clicks",
        label: "Clicks",
        valueBinding: "$parent.formatNumeric(clicks)",
        width: 88,
        minWidth: 80,
        required: true,
    },
    {
        key: "impressions",
        label: "Impressions",
        valueBinding: "$parent.formatNumeric(impressions)",
        width: 112,
        minWidth: 104,
        required: true,
    },
];
const listingComparisonColumns = [
    {
        key: "carrier",
        label: "Carrier",
        valueBinding: "carrier",
        width: 152,
        minWidth: 124,
        required: true,
    },
    {
        key: "ctr1Listing",
        label: "1 Listing",
        valueBinding: "$parent.formatNumeric(ctr1Listing, 2) + '%'",
        width: 100,
        minWidth: 92,
        required: true,
    },
    {
        key: "ctr2Listing",
        label: "2 Listings",
        valueBinding: "$parent.formatNumeric(ctr2Listing, 2) + '%'",
        width: 100,
        minWidth: 92,
        required: true,
    },
    {
        key: "ctr3Listing",
        label: "3 Listings",
        valueBinding: "$parent.formatNumeric(ctr3Listing, 2) + '%'",
        width: 100,
        minWidth: 92,
        required: true,
    },
];
const listingDistributionColumns = [
    {
        key: "listingsShown",
        label: "Listings Shown",
        valueBinding: "listingsShown",
        width: 132,
        minWidth: 120,
        required: true,
    },
    {
        key: "distribution",
        label: "Distribution",
        valueBinding: "$parent.formatNumeric(distribution, 0) + '%'",
        width: 112,
        minWidth: 104,
        required: true,
    },
    {
        key: "overallCtr",
        label: "Overall CTR",
        valueBinding: "$parent.formatNumeric(overallCtr, 0) + '%'",
        width: 112,
        minWidth: 104,
        required: true,
    },
];
const buyerColumns = [
    {
        key: "carrier",
        label: "Carrier",
        valueBinding: "carrier",
        width: 160,
        minWidth: 132,
        required: true,
    },
    {
        key: "avgBid",
        label: "Average Bid",
        valueBinding: "$parent.formatMoney(avgBid, 2)",
        width: 112,
        minWidth: 104,
        required: true,
    },
    {
        key: "avgPrice",
        label: "Average Price",
        valueBinding: "$parent.formatMoney(avgPrice, 2)",
        width: 120,
        minWidth: 112,
        required: true,
    },
];
const aggregatorFillRateColumns = [
    {
        key: "aggregator",
        label: "Aggregator",
        valueBinding: "aggregator",
        width: 160,
        minWidth: 132,
        required: true,
    },
    {
        key: "fillRate",
        label: "Fill Rate",
        valueBinding: "$parent.formatNumeric(fillRate, 0) + '%'",
        width: 104,
        minWidth: 96,
        required: true,
    },
    {
        key: "deltaFillRate",
        label: "Delta",
        valueBinding: "$parent.formatDelta(deltaFillRate, 0)",
        deltaBinding: "deltaFillRate",
        width: 96,
        minWidth: 88,
        required: true,
    },
];
const carrierFillRateColumns = [
    {
        key: "carrier",
        label: "Carrier",
        valueBinding: "carrier",
        width: 160,
        minWidth: 132,
        required: true,
    },
    ...aggregatorFillRateColumns.slice(1),
];
const clickListingTables = [
    {
        key: "cpc-aggregator-win-rate",
        exportId: "cpcAggregatorWinRate",
        title: "Win Rate by Aggregator",
        caption: "Click listing win rate by aggregator",
        source: "cpcAggregatorWinRate",
        columns: aggregatorWinRateColumns,
    },
    {
        key: "cpc-carrier-win-rate",
        exportId: "cpcCarrierWinRate",
        title: "Win Rate by Carrier",
        caption: "Click listing win rate by carrier",
        source: "cpcCarrierWinRate",
        columns: carrierWinRateColumns,
    },
    {
        key: "cpc-carrier-ctr",
        exportId: "cpcCarrierCtrs",
        title: "CTR by Carrier",
        caption: "Click-through rate by carrier",
        source: "cpcCarrierCtrs",
        columns: carrierCtrColumns,
    },
    {
        key: "cpc-listing-count-ctr",
        exportId: "cpcCarrierCtrsComparison",
        title: "CTR Across Listing Counts",
        caption: "Click-through rate comparison across listing counts",
        source: "cpcCarrierCtrs",
        columns: listingComparisonColumns,
    },
    {
        key: "cpc-listing-distribution",
        exportId: "cpcListingDistribution",
        title: "Performance by Listings Shown",
        caption: "Performance by number of click listings shown",
        source: "cpcListingDistribution",
        columns: listingDistributionColumns,
    },
    {
        key: "cpc-buyers",
        exportId: "cpcBuyers",
        title: "Buyers",
        caption: "Click listing buyers by carrier",
        source: "cpcBuyers",
        columns: buyerColumns,
    },
];
const dataLeadTables = [
    {
        key: "lead-aggregator-win-rate",
        exportId: "leadAggregatorWinRate",
        title: "Win Rate by Aggregator",
        caption: "Data lead win rate by aggregator",
        source: "leadAggregatorWinRate",
        columns: aggregatorWinRateColumns,
    },
    {
        key: "lead-carrier-win-rate",
        exportId: "leadCarrierWinRate",
        title: "Win Rate by Carrier",
        caption: "Data lead win rate by carrier",
        source: "leadCarrierWinRate",
        columns: carrierWinRateColumns,
    },
    {
        key: "lead-aggregator-fill-rate",
        exportId: "leadAggregatorFillRate",
        title: "Fill Rate by Aggregator",
        caption: "Data lead fill rate by aggregator",
        source: "leadAggregatorFillRate",
        columns: aggregatorFillRateColumns,
    },
    {
        key: "lead-carrier-fill-rate",
        exportId: "leadCarrierFillRate",
        title: "Fill Rate by Carrier",
        caption: "Data lead fill rate by carrier",
        source: "leadCarrierFillRate",
        columns: carrierFillRateColumns,
    },
    {
        key: "lead-buyers",
        exportId: "leadBuyers",
        title: "Buyers by Carrier",
        caption: "Data lead buyers by carrier",
        source: "leadBuyers",
        columns: buyerColumns,
    },
];
function renderCell(column) {
    const deltaClassName = column.deltaBinding ? " auction-insights-delta" : "";
    const deltaToneBinding = column.deltaBinding
        ? `, css: {
            'auction-insights-delta--positive': Number(${column.deltaBinding}) > 0,
            'auction-insights-delta--negative': Number(${column.deltaBinding}) < 0,
            'auction-insights-delta--neutral': Number(${column.deltaBinding}) === 0
        }`
        : "";
    return LpTable.Cell({
        column,
        children: html `
            <span class="lp-table_cell-content${deltaClassName}" data-bind="text: ${column.valueBinding}${deltaToneBinding}"></span>
        `,
    });
}
function renderBody(table) {
    return html `
        ${LpTable.Body({
        attributes: {
            "data-bind": `foreach: ${table.source}, visible: hasLoadedData`,
        },
        children: LpTable.Row({
            children: table.columns.map(renderCell),
        }),
    })}
        ${LpTable.SkeletonBody({
        columns: table.columns,
        rows: 6,
        label: `Loading ${table.title}`,
        attributes: {
            "data-bind": "visible: requestState() === 'loading' && !hasLoadedData()",
        },
    })}
        ${LpTable.StateBody({
        colSpan: table.columns.length,
        attributes: {
            "data-bind": `visible: requestState() !== 'loading' && ${table.source}().length === 0`,
            style: "display: none;",
        },
        children: LpEmpty({
            title: "No matching data",
            description: "No data matches the selected filters.",
            icon: "magnifying-glass",
            size: "sm",
        }),
    })}
    `;
}
function renderTable(table) {
    return LpModuleGridItem({
        className: "auction-insights-grid_item",
        attributes: {
            "data-auction-insight": table.key,
        },
        children: LpDataTable({
            title: html `
                <span class="lp-data-table_layer-title-content">
                    ${LpIcon({ name: "gavel", size: 16, className: "lp-data-table_layer-title-icon" })}
                    <span>${table.title}</span>
                </span>
            `,
            caption: table.caption,
            columns: table.columns,
            children: renderBody(table),
            showColumnMenu: false,
            stickyHeader: true,
            className: "auction-insights-table",
            actions: html `
                ${LpButton({
                label: "Export",
                prefixIcon: "download-simple",
                size: "sm",
                variant: "secondary",
                attributes: {
                    "data-bind": `click: function () { onExportTable('${table.exportId}'); }`,
                },
            })}
                ${LpModuleGridExpandButton({
                label: table.title,
            })}
            `,
        }),
    });
}
export function renderAuctionInsightsGrid() {
    return LpModuleGrid({
        columns: 2,
        className: "auction-insights-grid",
        children: html `
            <div
                class="auction-insights-grid_state"
                data-bind="visible: requestState() === 'error' && !hasLoadedData()"
                style="display: none;"
            >
                ${LpEmpty({
            title: "Unable to load auction insights",
            description: html `<span data-bind="text: requestError"></span>`,
            icon: "warning-circle",
            contents: LpButton({
                label: "Try again",
                prefixIcon: "arrows-clockwise",
                variant: "primary",
                attributes: { "data-bind": "click: onRetryData" },
            }),
            attributes: { role: "alert" },
        })}
            </div>
            <div
                class="auction-insights-grid_state"
                data-bind="visible: requestState() === 'error' && hasLoadedData()"
                style="display: none;"
            >
                ${LpBanner({
            title: "Refresh failed",
            description: html `<span data-bind="text: requestError"></span>`,
            icon: "warning-circle",
            variant: "error",
            actions: LpButton({
                label: "Retry",
                prefixIcon: "arrows-clockwise",
                size: "sm",
                attributes: { "data-bind": "click: onRetryData" },
            }),
        })}
            </div>
            ${LpModuleGridSection({
            title: "Click Listings",
            icon: "cursor-click",
            iconTone: "success",
            children: clickListingTables.map(renderTable),
        })}
            ${LpModuleGridSection({
            title: "Data Leads",
            icon: "database",
            iconTone: "warning",
            children: dataLeadTables.map(renderTable),
        })}
        `,
    });
}
